module.exports = __webpack_public_path__ + "img/external-link-symbol.c839058b.svg";